<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaDurataVerificariiTehnice')}} </h4>
        </div>
        <form id="revision_interval">
            <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                <v-select v-model="revision_interval" :options="interval" label="label" :placeholder="$t('placeholder.alegePerioada')"></v-select>
            </div>
            <div class="save-contact-buttons">
                <button @click.prevent='saveRevisionInterval()' :disabled="this.$store.state.loading">
                    <i class="fas fa-check"></i>
                    {{$t('placeholder.salveaza')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ServiceService from '../../api-services/service.service.js'
export default {
  name: 'ServiceSettings',
  data () {
    return {
      revision_interval: null,
      interval: [
        {
          label: '1 an',
          value: '1 an'
        },
        {
          label: '2 ani',
          value: '2 ani'
        },
        {
          label: '3 ani',
          value: '3 ani'
        }
      ]
    }
  },
  methods: {
    saveRevisionInterval () {
      let formData = new FormData(document.getElementById('revision_interval'))
      if (this.revision_interval) {
        formData.append('revision_interval', this.revision_interval.value)
      }
      ServiceService.settings(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.perioadaModificata'),
              'animation-type': 'css'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getServiceSettings () {

    }
  },
  mounted () {
    this.$store.dispatch('hideLoading')
    this.getServiceSettings()
  }
}
</script>
